import { CircularProgress, Typography } from "@material-ui/core";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AcnColorTheme } from "../../assets/css/AcnColorTheme";
import DynamicTitle from "../../component/DynamicTitle";
import TemplateComponent from "../../component/template/TemplateComponent";
import { UserVerifyRequest } from "../../models/RequestModel";
import { UserInfoModel } from "../../models/UserInfoModel";
import { ApiConfig, ServiceApi } from "../../service/ServiceApi";
import { RootState } from "../../store";
import { actions as UserAction } from "../../store/redux/UserInfoRedux";
import { actions as VerificationAction } from "../../store/redux/UserVerificationRedux";
import { NavTo } from "../../utils/AppManager";
import { Path, mobileNumberMask } from "../../utils/Constant";
import { defaultHeight, fontUnit, heightUnit, padGinUnit } from "../../utils/DeviceManager";
import { isMobileNumber } from "../../utils/SecureManager";
import MaskedInput from 'react-text-mask';
import { makeStyles } from "@material-ui/styles";

const iOS = require('is-ios');

export function MobileNumberScreen() {

    const classes = useStyles();
    const dispatch = useDispatch();
    const [userInfo] = useSelector((state: RootState) => [
        state.userInfoReducer.userInfo
    ]);

    const [mobile, setMobile] = useState("");
    const [message, setMessage] = useState("");
    const [maintenanceMessage, setMaintenanceMessage] = useState("");
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState(false);
    const SYSTEM_MAINTENANCE = "ขณะนี้เรากำลังปรับปรุงระบบ ขออภัยในความไม่สะดวก กรุณาลองใหม่ในภายหลัง";
    const USER_NOT_FOUND = "ไม่พบข้อมูลในระบบ กรุณาตรวจสอบหมายเลขแล้วลองอีกครั้ง หรือติดต่อ Call Center โทร. 02-777-7333 เพื่ออัปเดตหมายเลขโทรศัพท์มือถือ";
    const NO_INTERNET = "ขออภัย ไม่สามารถแสดงผลลัพธ์ได้ในขณะนี้ กรุณาลองอีกครั้ง"; //TLMSIT-7550

    const isValidMobile = () => {
        return isMobileNumber(mobile);
    }

    useEffect(() => {
        document.title = "สมัครใช้งาน\u200E\u200E\u200E\u200E"

    }, [])

    const verify = async (request: UserVerifyRequest) => {
        setIsFetching(true)
        let code = 0;
        axios.post(ServiceApi.VERIFICATION, request, ApiConfig).then(response => {
            return response.data
        })
            .then(data => {
                code = data.status
                const token = data.accessToken
                VerificationAction.setVerification(dispatch, data).then(() => {
                    setIsFetching(false)
                    NavTo(Path.otp)
                })
                    .catch(error => {
                        setIsFetching(false)
                        console.log(error)
                        setMaintenanceMessage(SYSTEM_MAINTENANCE)
                    })
            })
            .catch(error => {
                const errorResponse = error.response.data
                const unblockTime = errorResponse.unblockTime

                if (error.response.status === 400 && unblockTime){
                    VerificationAction.setVerification(dispatch, errorResponse).then(() => {
                        setIsFetching(false)
                        NavTo(Path.otp)
                    })                        
                        .catch(error => {
                            setIsFetching(false)
                            console.log(error)
                            setMaintenanceMessage(SYSTEM_MAINTENANCE)
                        })
                } else {
                    setIsFetching(false)
                    code = error.response.status
                    console.log(error.response.data.description)
                    console.log(error.response.status)
                    console.log(error.response.code)
                    if (error.response.status < 500){
                        setMessage(USER_NOT_FOUND)
                        setError(true)
                    } else {
                        setMaintenanceMessage(SYSTEM_MAINTENANCE)
                    }
                }
                // setIsFetching(false)
                // code = error.response.status
                // console.log("data.description : "+error.response.data.description)
                // console.log("status : "+error.response.status)
                // console.log("code : "+error.response.code)
                // console.log("error.accessToken : "+error.response.data.accessToken)
                // console.log("error.unblockTime : "+error.response.data.unblockTime)
                // if (error.response.status < 500){
                //     setMessage(USER_NOT_FOUND)
                // } else {
                //     setMessage(SYSTEM_MAINTENANCE)
                // }
                // setError(true)
            }).finally(() => {
                if (code === 0){
                    setMessage(NO_INTERNET)
                    setError(true)
                }
        })
    }

    const onConfirm = async () => {
        if (isValidMobile()) {
            console.log("-validated---------------------------")
            const newInfo: UserInfoModel = {...userInfo, mobile: mobile}
            UserAction.setUserInfo(dispatch, newInfo).then(() => {
                const request: UserVerifyRequest = {
                    recipientCID: userInfo.nationalId,
                    recipientPhoneNumber: mobile,
                    lineUserId: userInfo.lineUserId
                }
                console.log(`Try to verify line user`)
                verify(request)
            })
        }
    }

    const onLoading = () => {
        return (
            <Typography
                align={"center"}
                style={{
                    position: "relative",
                    width: "100%",
                    alignContent: "center",
                    paddingTop: padGinUnit(200),
                }}>
                <CircularProgress color='primary' style={{alignSelf: "center"}}/>
            </Typography>
        )
    }

    const mobileNumberWidget = () => {
        return (
            <div style={{position: 'fixed', overflow: "hidden", marginRight: '20px'}}>
                {/* <div style={{height: heightUnit(defaultHeight*0.82), overflowY: 'auto', overflowX: 'hidden'}}> */}
                <div style={{height: heightUnit(defaultHeight*0.82), overflowY: 'auto', overflowX: 'hidden'}}>
                    <DynamicTitle title={"กรุณากรอกหมายเลขโทรศัพท์มือถือ"} isFull={true} align={"left"} size={fontUnit(24)}/>
                    {/*<Typography align={"left"} style={{fontSize: fontUnit(16), color: AcnColorTheme.black, marginTop: !iOS? '' : padGinUnit(8)}}>*/}
                    {/*    ที่คุณเคยใช้ลงทะเบียนกับทางเงินไชโย*/}
                    {/*</Typography>*/}
                    {maintenanceMessage && (
                        <Typography align={"left"} style={{
                            width: "95%", 
                            color: AcnColorTheme.secondaryRed,
                            fontFamily: 'Prompt-Medium', 
                            fontSize: fontUnit(16),
                            marginTop: padGinUnit(8)
                        }}>
                            {maintenanceMessage}
                        </Typography>
                    )}
                    <Typography align={"left"} style={{color: AcnColorTheme.black}}>
                        <MaskedInput
                            mask={mobileNumberMask}
                            guide={false}
                            value={mobile}
                            className={classes.customPlaceholderStyle}
                            onChange={({currentTarget}) => {
                                const value = currentTarget.value
                                setMobile(value.replaceAll('-', ''))
                            }}
                            onKeyPress={event => {
                                if (event.key === 'Enter') {
                                    onConfirm()
                                }
                            }}
                            style={{
                                width: "93%", height: heightUnit(56), minHeight: 42, colorAdjust: "inherit", 
                                marginTop: padGinUnit(40), outline: "none", paddingLeft: padGinUnit(8),
                                fontSize: fontUnit(18), fontWeight: "normal", borderRadius: 8,
                                borderWidth: error? 2 : 0, 
                                borderColor: error? AcnColorTheme.secondaryRed: "black",
                                fontFamily: 'Prompt-Medium'
                            }}
                            id="mobilenumber"
                            type="tel"
                            name="mobilenumber"
                            placeholder="หมายเลขโทรศัพท์มือถือ"
                            autoComplete="off" 
                            title="เบอร์โทรศัพท์"
                            aria-labelledby="InputLabel"
                            aria-required="false" 
                            autoFocus
                            required
                        />
                    </Typography>
                    <Typography align={"left"} style={{
                        width: "95%", 
                        color: AcnColorTheme.secondaryRed,
                        padding: padGinUnit(8), 
                        fontSize: fontUnit(16),
                        marginTop: padGinUnit(8)
                    }}>
                        {message}
                    </Typography>
                    <div style={{height: !iOS? '250px':''}} />
                </div>
            </div>
        )
    }

    return (
        <TemplateComponent content={(isFetching) ? onLoading() : mobileNumberWidget()}
                           onNext={onConfirm}
                           isCanNext={isValidMobile() && !isFetching}
                           nextText={"ยืนยัน"}/>
    );
}


const useStyles = makeStyles(() => ({
  
    customPlaceholderStyle: {
        '&::placeholder': {
          color: '#BCC1C7'
        },
    }
}))